/**
 * PartFourSlides.tsx
 * ------------------
 * Learning slides for crash course part four.
 * - Multilingual content.
 * - Updates progress and points on completion.
 */

import React from 'react';
import { useProgress } from '../../../context/ProgressContext';
import Button from '../../common/Button';
import { useHistory } from 'react-router-dom';
import Box from '../../common/Box';

const t = {
  slide1_title: {
    fi: 'Yhteenveto',
    en: 'Recap',
    sv: 'Sammanfattning',
  },
  slide1_content: {
    fi: 'Olet nyt oppinut saunan ja sähkölaitteiden turvallisen käytön perusteet suomalaisissa oloissa.',
    en: 'You have now learned the basics of safe sauna and appliance use in Finnish conditions.',
    sv: 'Du har nu lärt dig grunderna i säker bastu- och apparatanvändning i finländska förhållanden.',
  },
  slide2_title: {
    fi: 'Tärkeimmät opit',
    en: 'Key Takeaways',
    sv: 'Viktigaste lärdomarna',
  },
  slide2_content: {
    fi: 'Muista valvoa saunan käyttöä, tarkista laitteet ennen käyttöä ja vältä kosteita olosuhteita sähköllä.',
    en: 'Remember to supervise sauna use, check devices before use, and avoid using electricity in wet conditions.',
    sv: 'Kom ihåg att övervaka bastuanvändning, kontrollera apparater före användning och undvik fuktiga miljöer vid elanvändning.',
  },
  slide3_title: {
    fi: 'Seuraavat askeleet',
    en: 'Next Steps',
    sv: 'Nästa steg',
  },
  slide3_content: {
    fi: 'Harjoittele turvallista käyttöä kotona ja jaa oppimasi myös muille!',
    en: 'Practice safe usage at home and share what you’ve learned with others!',
    sv: 'Öva säker användning hemma och dela dina kunskaper med andra!',
  },
  video_title: {
    fi: 'Katso: Turvallisuuden yhteenveto',
    en: 'Watch: Safety Recap',
    sv: 'Titta: Säkerhetssammanfattning',
  },
  back: {
    fi: 'Takaisin kurssi yleisnäkymään',
    en: 'Back to course overview',
    sv: 'Tillbaka till kursöversikten',
  },
};

export const PartFourSlides = () => {
  const progress = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(progress.language) ? progress.language : 'fi') as
    | 'en'
    | 'fi'
    | 'sv';
  const history = useHistory();
  const latestCompletedStep = Number(localStorage.getItem('latestCompletedStep'));
  const currentPoints = Number(localStorage.getItem('points'));
  const partFourBadge = localStorage.getItem('partFourDone');

  return (
    <div className="flex flex-col min-h-screen justify-evenly p-16">
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide1_title[lang]}</h2>
        <p>{t.slide1_content[lang]}</p>
      </Box>
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide2_title[lang]}</h2>
        <p>{t.slide2_content[lang]}</p>
      </Box>
      <Box className="my-4">
        <h2 className="text-xl font-bold mb-2">{t.slide3_title[lang]}</h2>
        <p>{t.slide3_content[lang]}</p>
      </Box>
      <Button
        gradient={false}
        className="bg-gradient-to-r from-green-600 to-green-500 \
        hover:from-green-700 hover:to-green-600 w-1/4 flex-col self-end"
        onClick={() => {
          if (currentPoints != 40 && !partFourBadge) {
            localStorage.setItem('points', String(currentPoints + 10));
            localStorage.setItem('partFourDone', 'true');
          }
          if (latestCompletedStep < 4) {
            localStorage.setItem('latestCompletedStep', '4');
          }
          history.push('/crash-course');
        }}
      >
        {t.back[lang]}
      </Button>
    </div>
  );
};
